import { useState } from 'react';
import { Box } from '@mui/material';

import AdminSidebar from '../components/admin/AdminSidebar';
import HomePageAdminPage from './HomePageAdminPage';
import AddonsPage from './AddonsPage';
import SkinsPage from './SkinsPage';

export default function AdminLayout() {
  const [tab, setTab] = useState('addons');

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <AdminSidebar activeTab={tab} onChangeTab={setTab} />

      <Box sx={{ flex: 1, bgcolor: '#fafafa' }}>
        {tab === 'home' && <HomePageAdminPage />}
        {tab === 'addons' && <AddonsPage />}
        {tab === 'skins' && <SkinsPage />}
      </Box>
    </Box>
  );
}
